// extracted by mini-css-extract-plugin
export default {"Vcard":"Transaction_Vcard__svuBe","VAcctTxt":"Transaction_VAcctTxt__TZ5MQ","VFundTxt":"Transaction_VFundTxt__ofrd1","VBank":"Transaction_VBank__hg1e+"};